import { StaticImage } from "gatsby-plugin-image"
import React from "react"

const texts = {
  pt: [
    "Time administrativo",
    <>
      A manutenção e administração do site Camarades Brasil é de responsabilidade
      do{" "}
      <a
        href="https://labnec.ccb.ufsc.br/camarades-brasil/"
        target="_blank"
        rel="noopener noreferrer"
      >
        Labnec-CFS-CCB-UFSC
      </a>{" "}
      da Universidade Federal de Santa Catarina.
    </>,
  ],
  en: [
    "Administrative team",
    <>
      The maintenance and administration of the Camarades Brazil website is the
      responsibility of{" "}
      <a
        href="https://labnec.ccb.ufsc.br/camarades-brasil/"
        target="_blank"
        rel="noopener noreferrer"
      >
        Labnec-CFS-CCB-UFSC
      </a>{" "}
      at Universidade Federal de Santa Catarina.
    </>,
  ],
}

export default function TeamBanner({ language }) {
  const text = texts[language]

  return (
    <section className="row ">
      <div className="col-sm-12 col-md-6 mr-1 d-flex align-items-center">
        <div className="team-card">
          <h3>{text[0]}</h3>
          <p className="text-muted">{text[1]}</p>
          <div className="row align-items-center">
            <div className="col d-flex justify-content-center">
              <a
                href="https://ufsc.br/"
                className="text-decoration-none"
                target="_blank"
                rel="noopener noreferrer"
              >
                <StaticImage
                  src="../../../assets/images/sponsors/ufsc.png"
                  alt="UFSC"
                />
              </a>
            </div>
            <div className="col d-flex justify-content-center">
              <a
                href="https://labnec.ccb.ufsc.br/camarades-brasil/"
                className="text-decoration-none"
                target="_blank"
                rel="noopener noreferrer"
              >
                <StaticImage
                  src="../../../assets/images/team/labnec.png"
                  alt="LABNEC UFSC"
                />
              </a>
            </div>
            <div className="col d-flex justify-content-center">
              <a
                href="https://labnec.ccb.ufsc.br/camarades-brasil/"
                className="text-decoration-none"
                target="_blank"
                rel="noopener noreferrer"
              >
                <StaticImage
                  src="../../../assets/images/team/cb-ufsc.png"
                  alt="Ciências Biológicas UFSC"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="col-sm-12 col-md-6 d-flex align-items-center">
        <StaticImage
          src="../../../assets/images/generics/team.png"
          alt="time"
        />
      </div>
    </section>
  )
}
